import React, { ReactNode, FC } from "react"
import { createStructuredSelector } from "reselect"
import { connect } from "react-redux"

// Selectors
import { selectPrimaryActionColor } from "Containers/BusinessInformations/selectors"

// Styles
import { ButtonStyle } from "Components/UiKit/Button/index.style"

interface ButtonProps {
  onClick?: (props?: any) => void
  expendOnHover?: boolean
  children: ReactNode
  disabled?: boolean
  loading?: boolean
  type: string
  // Style
  primaryColor?: string
  marginIcon?: string
  margin?: string
  width?: string
}

const Button: FC<ButtonProps> = ({
  onClick,
  expendOnHover,
  children,
  disabled,
  loading,
  type,
  // Style
  primaryColor,
  marginIcon,
  margin,
  width,
}) => (
  <ButtonStyle
    onClick={loading ? () => {} : onClick}
    expendOnHover={expendOnHover}
    disabled={disabled || loading}
    type={type}
    // Style
    primaryColor={primaryColor}
    marginIcon={marginIcon}
    margin={margin}
    width={width}
  >
    {children}
  </ButtonStyle>
)

const mapStateToProps = createStructuredSelector({
  primaryColor: selectPrimaryActionColor,
})

export default connect(mapStateToProps, null)(Button)
